import React, { useEffect, useState } from "react";
import ClickArea from "containers/click_area/index";
import BottomContent from "containers/bottom_content/index";
import HomePage from "./home_page";
import Audio from "containers/audio";
import InviterPage from "containers/inviterPage";
import { getBill_Info } from "../../api/index.js";
import TransitionPag from "./transition_pag";
// import HomePag from "./home_pag";
import { parse } from "../../utils/getParams";
import { getParamByUrl } from "../../components/index";
import { getCheckVisit } from "api";
import { Decrypt } from "../../utils/secret";
import "./index.less";
import message from "components/message";
// import transitionPng from "assets/img/transition.png";
import ClosePage from "containers/close_page";

function Main() {
  const t = window.t;
  // mock
  const [showHomePage, setShowHomePage] = useState(true);
  const [showTransitionPag, setShowTransitionPag] = useState(false);
  const [isInviterPage, setisInviterPage] = useState(false);
  const [clickProps, setClickProps] = useState(null);
  // 直接展示地图页
  const [directShowMap, setDirectShowMap] = useState(false);
  // 用户是否访问过页面
  const [isAlreadySeen, setIsAlreadySeen] = useState(undefined);

  const [isLoading, setIsLoading] = useState(false);
  // 等待转场动画加载完成
  const [transitionPngReady, setTransitionPngReady] = useState(false);
  // 展示底部按钮
  const [showClickArea, setShowClickArea] = useState(false);
  // 接口获取数据失败
  const [getDataError, setGetDataError] = useState(false);
  // 音乐播放
  const [player, setPlayer] = useState(false);
  // 摧毁过场动画
  const [destoryTransition, setDestoryTransition] = useState(false);
  // 展示关键词模块
  const [showKeyword, setShowKeyword] = useState(false);

  // 是否登录
  // 是否登录可以根据uid来判断
  const isLogin = window.$$uid && window.$$uid !== -1 ? true : false;
  let smallScreen = false;
  let bodyWidth = document.body.clientWidth;
  let bodyHeight = document.body.clientHeight;
  if (window.$$isMobile) {
    bodyWidth = document.documentElement.clientWidth;
    bodyHeight = document.documentElement.clientHeight;
  }
  if (bodyWidth / bodyHeight > 414 / 800) {
    smallScreen = true;
  }

  useEffect(() => {
    if (getParamByUrl("p")) {
      let p = getParamByUrl("p");
      let data = parse(Decrypt(p));
      let params = data.api_sign
        ? { api_sign: data.api_sign }
        : { api_pver: data.api_pver };
      getInfo({ uid: data?.uid, ...params }, () => {
        setisInviterPage(true);
      });
    } else if (window.$$can_awake_up_app) {
      // 不是点击分享链接进入的，同时符合唤醒App条件；
      window.location.href = window.$$awake_target;
    } else {
      // 正常模式，兜底
      getInfo();
    }
  }, []);

  useEffect(() => {
    // 查询用户是否访问过地图页
    getCheckVisit({ type: "get" })
      .then((res) => {
        const { code } = res;
        if (code === 20000) {
          const { data } = res;
          if (!Number(data.is_first_visit)) {
            setIsAlreadySeen(true);
          } else {
            setIsAlreadySeen(false);
          }
        } else if (isLogin) {
          setIsAlreadySeen(false);
          handleDataError();
        }
      })
      .catch(() => {
        setIsAlreadySeen(false);
        setGetDataError(true);
        if (isLogin) {
          message({
            type: "noIcon",
            content: t("Load failed, please try again!"),
            isHomePage: true,
          });
        }
      });
  }, []);

  const handleDataError = () => {
    setGetDataError(true);
    message({
      type: "noIcon",
      content: t("Load failed, please try again!"),
      isHomePage: true,
    });
  };

  const hideInviterPage = () => {
    setShowTransitionPag(true);
    setisInviterPage(false);
  };
  //  获取userInfo 如果没登录就不访问
  const getInfo = (params, setInviterPage) => {
    if (isLogin) {
      getBill_Info(params)
        .then((res) => {
          if (res.code === 20000) {
            setClickProps(res.data);
            setInviterPage && setInviterPage();
          } else if (isLogin) {
            handleDataError();
          }
        })
        .catch(() => {
          handleDataError();
        });
    }
  };

  const handleDirectShowMap = () => {
    setDirectShowMap(true);
    // 移除home-page HomePage节点
    const homePageEle = document.querySelector(".home-page");
    homePageEle.style.display = "none";

    // setTimeout(() => {
    // const cloudBox = document.querySelector("#cloud");
    // cloudBox.classList.add("cloudBox");
    // const timeOut = setTimeout(() => {
    //   cloudBox.style.display = "none";
    //   clearTimeout(timeOut);
    // }, 2000);
    // }, 10);
  };

  // if(toMap === -1 && isLogin) {
  //   return <Loading showLoading={true} />
  // }

  return (
    <div className="year-report">
      <>
        {/* 查看分享详情 */}
        {isInviterPage && (
          <InviterPage hideInviterPage={hideInviterPage} {...clickProps} />
        )}
        {/* 首页旋转小地球 */}
        {/* {!transitionPngReady && !isInviterPage && !directShowMap && (
          <HomePag smallScreen={smallScreen} />
        )} */}
        {/* 转场动画 */}

        {/* {showTransitionPag && ( */}
        {/* {!isInviterPage && (
          <TransitionPag
            showTransitionPag={showTransitionPag}
            setShowTransitionPag={setShowTransitionPag}
            setShowHomePage={setShowHomePage}
            directShowMap={directShowMap}
            smallScreen={smallScreen}
            destoryTransition={destoryTransition}
          />
        )} */}
        {/* )} */}

        {/* 首页 */}
        {!isInviterPage && showHomePage && (
          <HomePage
            setShowTransitionPag={setShowTransitionPag}
            showTransitionPag={showTransitionPag}
            setShowHomePage={setShowHomePage}
            handleDirectShowMap={handleDirectShowMap}
            isAlreadySeen={isAlreadySeen}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isLogin={isLogin}
            getDataError={getDataError}
            setPlayer={setPlayer}
          />
        )}

        {/* 地图页动效 */}
        {/* {!false && ( */}
        {!showHomePage && (
          <BottomContent
            setShowClickArea={setShowClickArea}
            showHomePage={showHomePage}
            setDirectShowMap={setDirectShowMap}
            setDestoryTransition={setDestoryTransition}
          />
        )}
        {/* 地图点击、详情 */}
        {!showHomePage && clickProps && showClickArea && (
          <ClickArea
            showKeyword={showKeyword}
            props={{ ...clickProps }}
            directShowMap={directShowMap}
          />
        )}
      </>
      <Audio
        showKeywordEntry={showClickArea}
        player={player}
        setPlayer={setPlayer}
        showKeyword={showKeyword}
        setShowKeyword={setShowKeyword}
      />
      {/* <ClosePage /> */}
      {/* 图片预加载 */}
      <div id="homage-main-preload-image"></div>
    </div>
  );
}

export default Main;
